import { useEffect, MutableRefObject } from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, useTheme } from 'styled-components';
import LazyImage from '@/components/features/lazyImage/LazyImage';

const useLazyLoadImages = (ref: MutableRefObject<HTMLDivElement | null>) => {
	const theme = useTheme();

	useEffect(() => {
		if (ref.current) {
			const images = ref.current.querySelectorAll('img:not(.exclude)');
			images.forEach(img => {
				const src = img.getAttribute('src');
				const alt = img.getAttribute('alt');
				const parent = img.parentElement;

				if (src && alt && parent) {
					const imgElement = new Image();
					imgElement.src = src;
					const lazyImageContainer = document.createElement('div');

					imgElement.onload = () => {
						const width = imgElement.width;
						lazyImageContainer.className = 'lazy-image-container';
						lazyImageContainer.style.width = `${width}px`;
					}

					parent.replaceChild(lazyImageContainer, img);

					const root = createRoot(lazyImageContainer);

					root.render(
						<ThemeProvider theme={theme}>
							<LazyImage src={src} alt={alt} />
						</ThemeProvider>
					);
				}
			});
		}
	}, [ref, theme]);
};

export default useLazyLoadImages;
